import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo, useState } from "react";
import { equals, pick } from "ramda";
import { useParams } from "react-router-dom";
import { dateConvertKeys } from "utils/dates";
import { measureGroupTypeId } from "utils/measures";
import { isEmptyObject } from "utils/validation";
import { measurementsParams } from "utils/measurementsWithMetadata";
import { useMeasureDetail } from "@webapi/hooks/useMeasureDetail";
import { useCustomEffect } from "hooks";
import { useQueryContext } from "contexts/searchParams";
var modelParams = pick(["parentMeasure", "measureIds", "units", "periodType", "dateFrom", "dateTo", "relatedMeasuresByEntry", "relatedMeasuresById"]);
export default function useMeasureDetailRoute() {
  var _useParams = useParams(),
    id = _useParams.id;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isReady = _useState2[0],
    setIsReady = _useState2[1];
  var _useQueryContext = useQueryContext(),
    appState = _useQueryContext.appState,
    setPartialAppState = _useQueryContext.setPartialAppState,
    currSearchParams = _useQueryContext.currSearchParams;
  var hydratedParams = _objectSpread({
    parentMeasure: id,
    measureIds: [id],
    units: []
  }, currSearchParams);
  var _useMeasureDetail = useMeasureDetail(modelParams(hydratedParams)),
    measureDetail = _useMeasureDetail.measureDetail,
    loadingMeasureDetail = _useMeasureDetail.loading,
    measureDetailError = _useMeasureDetail.error;
  useCustomEffect(function () {
    var _measureDetail$metada;
    if (!equals(id, (_measureDetail$metada = measureDetail.metadata) === null || _measureDetail$metada === void 0 ? void 0 : _measureDetail$metada.id)) {
      setIsReady(false);
    }
  }, [id]);
  useCustomEffect(function () {
    if (!isEmptyObject(measureDetail)) {
      var defaultEntry = measureDetail.measureDetailDefaultParameters.relatedMeasuresByEntry;
      var translatedParams = Object.keys(measureGroupTypeId).find(function (key) {
        return measureGroupTypeId[key] === defaultEntry;
      });
      var defaultEntryId = measureDetail.measureDetailDefaultParameters.relatedMeasuresById;
      var fetchedParams = dateConvertKeys(["dateFrom", "dateTo"], _objectSpread(_objectSpread({}, measurementsParams(measureDetail.inputParameters)), {}, {
        parentMeasure: measureDetail.metadata.parentMeasure,
        relatedMeasuresById: hydratedParams.relatedMeasuresById || defaultEntryId,
        relatedMeasuresByEntry: hydratedParams.relatedMeasuresByEntry || translatedParams
      }));

      // keep default units for first load
      if (fetchedParams.units.length === 0) fetchedParams.units = hydratedParams.units;
      var relatedParams = pick(["relatedMeasuresByEntry", "relatedMeasuresById"]);

      /*
      If the fetched measuredetail indicates that our params mismatch what is available or includes the wrong relatedProps
      we need to trigger an update in the appState so that it reflects what was sent back from the server.
      */
      if (!equals(measurementsParams(fetchedParams), measurementsParams(appState)) || !equals(relatedParams(appState), relatedParams(fetchedParams))) {
        setPartialAppState(fetchedParams, true);
      }
      setIsReady(true);
    }
  }, [measureDetail]);
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, !isReady ? {} : measureDetail), {}, {
      loading: loadingMeasureDetail,
      error: measureDetailError,
      appState: appState,
      setPartialAppState: setPartialAppState
    });
  }, [isReady, measureDetail, loadingMeasureDetail, measureDetailError, appState, setPartialAppState]);
}